export default {
  honorTitle: '获得荣誉',
  honorSubtitle: '国家高新技术企业',
  certTitle: '资质证书',
  certSubtitle: '国家高新技术企业',
  contactUsTitle: '联系我们',
  contactUsSubtitle: '国家高新技术企业',
  footer: {
    phone: '400-0372-203',
    onlineTime: '8：00——22：00',
    address: '河南省林州市863科技产业园综合楼4层',
    copyright: '© 2014-2022悟能科技版权所有 豫ICP备17039503号-1',
    list: [{
      title: '系列产品',
      id: '1',
      children: [{
        id: '1',
        text: "智慧物业"
      }, {
        id: '2',
        text: "智慧园区"
      }, {
        id: '3',
        text: "城际约车",
        src: '/chauffeur'
      }, {
        id: '4',
        text: "社区拼团",
        src: '/community_group'
      }]
    }, {
      title: '合作加盟',
      id: '2',
      children: [{
        id: '1',
        text: "加盟流程",
        src: '/cooperate'
      }]
    }, {
      title: '关于我们',
      id: '3',
      children: [{
        id: '1',
        text: "公司简介",
        src: '/about'
      }, {
        id: '2',
        text: "公司荣誉",
        src: '/about'
      }, {
        id: '3',
        text: "联系我们",
        src: '/contactUs'
      }]
    }]
  }
};